import { useCallback } from 'react';

import Container from '@ui/container/container';
import GoogleMeetFiresides from '../../project-sessions-row/add-new-session/google-meet-firesides';
import { useAppDispatch } from '@/store/hooks';
import { saveWorkingProjectSessionByField } from '@/store/slices/project';
import { TReactSelectOption } from '@ui/select/react-select/custom-react-select.types';
import { Session } from '@/types/session.types';

type FiresideSettingsProps = {
  session: Session;
  emails: TReactSelectOption<string, string>[];
};

const FiresideSettings = ({ session, emails }: FiresideSettingsProps) => {
  const dispatch = useAppDispatch();

  const handleSetFiresideHosts = useCallback(
    (emails: TReactSelectOption[]) => {
      dispatch(
        saveWorkingProjectSessionByField({
          uuid: session.uuid,
          firesides_hosts: emails.map((email) => email.value.toString()),
        })
      );
    },
    [dispatch, session.uuid]
  );

  return (
    <Container minHeight="82px" maxHeight="104px">
      <GoogleMeetFiresides hostEmails={emails} setHostEmails={handleSetFiresideHosts} />
    </Container>
  );
};

export default FiresideSettings;
